/* src/app/views/template/components/edit-template-menu/edit-template-marketing-menu/edit-template-marketing-featured-category-menu/edit-template-marketing-featured-category-menu.component.scss */
/*# sourceMappingURL=edit-template-marketing-featured-category-menu.component.css.map */
